import { LoadStatusModel } from '@modules/shared/models/common';

export interface DirectoryLoadStatusViewModel extends LoadStatusModel {
    isCompanyLoaded: boolean,
    isFollowerLoaded: boolean,
    isFollowingLoaded: boolean,
    companyDirectoryTotal: number,
    followerDirectoryTotal: number,
    followingDirectoryTotal: number,
    isCompanyCanLoadMore: boolean,
    isFollowerCanLoadMore: boolean,
    isFollowingCanLoadMore: boolean,
    isCompanyForceLoad: boolean,
    isFollowerForceLoad: boolean,
    isFollowingForceLoad: boolean
}
